module.exports = __webpack_public_path__ + "img/Our Culture.8e17aaa4.png";